import App from './App';
import './Css/App.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/es/integration/react';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { SettingsProvider } from './context/SettingsProvider';
import { GenericModalProvider } from './context/GenericModalProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate load={null} persistor={persistor}>
        <BrowserRouter>
          <SettingsProvider>
            <GenericModalProvider>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </GenericModalProvider>
          </SettingsProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
